import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  UncontrolledTooltip
} from "reactstrap";
import { Link } from "react-router-dom";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";

const KRAFactor = () => {
  const [data, setData] = useState([
    { id: 1, kra: "Classroom (Readiness)", isActive: true },
    { id: 2, kra: "Personnel Development (Special Initiatives & Event Allocation)", isActive: true },
    { id: 3, kra: "Responsibility and Ownership (Examination & Audit)", isActive: true },
    { id: 4, kra: "Mentorship Development (Target for next year)", isActive: true },
    { id: 5, kra: "Mentorship Development (Team)", isActive: true },
    { id: 6, kra: "Mentorship Development (Individual)", isActive: true },
    { id: 7, kra: "Responsibility and Ownership (Handling Students)", isActive: true },
    { id: 8, kra: "Responsibility and Ownership (Time)", isActive: true },
    { id: 9, kra: "Responsibility and Ownership (Classroom)", isActive: true },
    { id: 10, kra: "Personnel Development (Interpersonal Skill)", isActive: true },
  ]);


  const [isEdit, setIsEdit] = useState(false);
  const [editId, setEditId] = useState(null);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      kra: "",
    },
    validationSchema: Yup.object({
      kra: Yup.string().required("Please Enter Head Name"),
    }),
    onSubmit: (values, { resetForm }) => {
      if (isEdit) {
        setData((prevData) =>
          prevData.map((item) =>
            item.id === editId ? { ...item, ...values } : item
          )
        );
        setIsEdit(false);
        setEditId(null);
      } else {
        const newRow = {
          id: data.length + 1,
          ...values,
          isActive: true,
        };
        setData((prev) => [...prev, newRow]);
      }
      resetForm();
    },
  });

  const handleEdit = (row) => {
    formik.setValues({
      kra: row.kra,
    });
    setIsEdit(true);
    setEditId(row.id);
  };

  const handleCancel = () => {
    formik.resetForm();
    setIsEdit(false);
    setEditId(null);
  };

  const handleToggleStatus = (row) => {
    setData((prevData) =>
      prevData.map((item) =>
        item.id === row.id ? { ...item, isActive: !item.isActive } : item
      )
    );
  };

  const columns = [
    {
      Header: "S.No",
      Cell: ({ row }) => data.length - row.index,
      className: "serial-no",
      applyHeaderClass: true,
    },
    {
      Header: "KRA",
      accessor: "kra",
    },
    {
      Header: "Edit",
      className: "serial-no",
      applyHeaderClass: true,
      Cell: (cellProps) => {
        return (
          <Link
            to="#"
            className="text-success"
            onClick={() => handleEdit(cellProps.row.original)}
          >
            <i className="bx bxs-edit font-size-18" id="edittooltip" />
            <UncontrolledTooltip placement="top" target="edittooltip">
              Edit
            </UncontrolledTooltip>
          </Link>
        );
      },
    },
    {
      Header: "Status",
      className: "status-col",
      applyHeaderClass: true,
      Cell: (cellProps) => {
        const isActive = cellProps.row.original.isActive;
        return (
          <Link
            to="#"
            style={{ color: isActive ? "green" : "red" }}
          >
            <i
              className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"
                } font-size-18`}
              id={`status-tooltip-${cellProps.row.id}`}
            />
            <UncontrolledTooltip
              placement="top"
              target={`status-tooltip-${cellProps.row.id}`}
            >
              {isActive ? "Active" : "Inactive"}
            </UncontrolledTooltip>
          </Link>
        );
      },
    },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Performance" breadcrumbItem="kra" />

          {/* Input Section */}
          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row className="mb-3 g-3 align-items-center">
                  <Col md="6">
                    <FormGroup>
                      <Label for="kra">
                        KRA <span className="text-danger">*</span></Label>
                      <Input
                        id="kra"
                        name="kra"
                        type="text"
                        value={formik.values.kra}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={
                          formik.touched.kra &&
                          Boolean(formik.errors.kra)
                        }
                      />
                      {formik.touched.kra && formik.errors.kra && (
                        <div className="text-danger">{formik.errors.kra}</div>
                      )}

                    </FormGroup>
                  </Col>
                  <Col md="6" className="d-flex align-items-center justify-content-end mt-4">
                    <Button type="submit" className="btn button-save me-2">
                      <i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                    </Button>
                    <Button type="button" className="btn button-cancel" onClick={handleCancel}>
                      <i className="fas fa-sync me-1" /> Cancel
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>

          {/* Table Section */}
          <Card>
            <CardBody>
              <TableContainer
                columns={columns}
                data={data}
                isGlobalFilter={true}
                customPageSize={10}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default KRAFactor;
